/**
 * Plain-language labels for citizen-facing demos.
 * Keep CLAW / skill / package jargon off the public UI.
 */

const TOOL_LABELS = {
  if_advise_application_intake: 'Application guidance',
  if_sf_application_advisor: 'Application path',
  if_resolve_intake_requirements: 'Checked requirements',
  if_ingest_intake_attachment: 'Read your upload',
  if_extract_intake_fields: 'Suggested form answers',
  if_review_site_plan: 'Reviewed site plan',
  if_query_agency_policy: 'Looked up city policy',
  if_assess_completeness: 'Checked completeness',
  if_explain_fees: 'Explained fees',
  if_counter_brief: 'Counter visit tips',
  if_status_coach: 'Status update',
  if_explain_zoning: 'Zoning guidance',
  if_plan_corrections: 'Correction plan',
  if_suggest_inspection_assignment: 'Suggested inspector',
  if_assign_inspection: 'Assigned inspector',
  if_prepare_inspection: 'Inspection checklist',
  if_permit_portfolio: 'Permit path overview',
  if_advise_intake: 'Intake guidance',
};

const CITY_NAMES = {
  'san-francisco': 'San Francisco',
  berkeley: 'Berkeley',
  'san-jose': 'San José',
  'demo-generic': 'Demo city',
};

export function friendlyToolLabel(toolIdOrName) {
  const raw = String(toolIdOrName || '').trim();
  if (!raw) return 'Guidance step';
  if (TOOL_LABELS[raw]) return TOOL_LABELS[raw];
  const snake = raw.replace(/^if[_-]/i, '').replace(/[_-]+/g, ' ');
  if (snake !== raw) {
    return snake.charAt(0).toUpperCase() + snake.slice(1);
  }
  return raw;
}

export function friendlyCityLabel(packageId) {
  const id = String(packageId || '').trim().toLowerCase();
  if (!id) return 'your city';
  if (CITY_NAMES[id]) return CITY_NAMES[id];
  return id.split('-').map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
}

export function friendlyPhaseChip(phase) {
  if (phase === 'submitted') return 'Submitted';
  if (phase === 'draft') return 'Draft ready';
  return 'In progress';
}
